import cn from './styles.module.sass';

export const InviteSuccessContent = () => {
    return (
        <div className={cn.container}>
            <div className={cn.imgWrapper}>
                <img src="/images/main/success_reservation.svg" alt="" />
            </div>
            <div className={cn.text}>
                <h2>Ссылка успешно скопирована</h2>
                <p>Отправь ссылку другу, которого хочешь пригласить в Другоманию</p>
            </div>
        </div>
    );
};
